import { Formik } from 'formik';
import React, { useCallback, useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { GoLocation, GoDot } from 'react-icons/go';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { MdBusiness, MdCheck, MdClose, MdContentCopy } from 'react-icons/md';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import * as Yup from "yup";
import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from 'components/layout/form/outlinedButton';
import RadioField from 'components/layout/form/radioField';
import TextField from 'components/layout/form/textField';
import CondoUnavailable from 'components/MI/adesao/CondoUnavailable';
import BlockMigration from './BlockMigration';
import api from 'services/api';
import { registerValuesMembership, toggleMembershipStep } from 'store/actions/membership-actions';
import theme from 'styles/theme';
import {
  ButtonsContainer,
  ButtonSelect,
  CondoContainer,
  CondoIcon,
  CondoSelectedContainer,
  Container,
  Error,
  FieldSelect,
  FormContainer,
  Header,
  HeaderForm,
  InfoCard,
  InputsContainer,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalStyle,
  ReCAPTCHAContainer,
  SelectCondoConatoner,
  Selector,
  SelectTypeContainer,
  Tooltip
} from './styles';
import axios from 'axios';

const Registration = ({ dispatch, document, condominiumByCode, condominiumByZipCode, condoZipCode, condoCode, membershipReducer }) => {
  const [loading, setLoading] = useState(false);
  const [showCondoUnavailableModal, setShowCondoUnavailableModal] = useState(false);
  const [showModalBond, setShowModalBond] = useState(false);
  const [showModalSwitch, setShowModalSwitch] = useState(false);
  const [modalValues, setModalValues] = useState({});
  const [recaptchaKey] = useState(process.env.REACT_APP_RECAPTCHAR_PUBLIC);
  const [numberAattempts, setNumberAattempts] = useState(0);
  const [reCapcharControler, setReCapcharControler] = useState({ show: true, token: "init" });
  const [condominiumByCodeState, setCondominiumByCode] = useState(condominiumByCode);
  const [condominiumByZipCodeState, setcondominiumByZipCode] = useState(condominiumByZipCode);
  const [addressList, setAddressList] = useState();
  const [isMigrating, setIsMigrating] = useState(false);
  const reCapcharRef = useRef(null);
  const isProduction = process.env.REACT_APP_ENV === 'build-prod';

  const resetReCapchar = useCallback(() => {
    if (reCapcharRef && reCapcharRef.current && reCapcharRef.current.reset) {
      reCapcharRef.current.reset();
      setReCapcharControler({ ...reCapcharControler, token: null });
    }
  }, [reCapcharControler, setReCapcharControler, reCapcharRef]);

  const recaptcharCount = useCallback(() => {
    setNumberAattempts(numberAattempts + 1);
    if (numberAattempts === 3 && isProduction) {
      setReCapcharControler({ ...reCapcharControler, token: null })
    }
  }, [setNumberAattempts, numberAattempts, setReCapcharControler, reCapcharControler, isProduction])

  const requestGetAccessToken = useCallback(async () => {
    const req = axios.create({
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Accept-Language": "pt-BR",
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
      baseURL: process.env.REACT_APP_API_URL_OAUTH,
      });

    const header = {
      "Content-Type": "application/json",
      "Accept-Language": "pt-BR",
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
    };
    const parameters = {
      method: "POST",
      headers: header,
    };
    const body = {
      grant_type: "client_credentials",
    };

    let access_token = "";

    try {
      const response = await req.post("oauth/access-token", body, parameters);
      access_token = response.data.access_token
    } catch (error) {
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {
          toast.error(message);
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }

    return access_token;
  }, []);

  const requestGetCondominiusByZipCode = useCallback(async (zipcode) => {
    setLoading(true);
    const access_token = await requestGetAccessToken();
    const headers = {
      access_token
    }
    const params = {
      "zip-code": zipcode
    }

    try {
      const response = await api.get("industrial/customer/v1/condominiums", { params, headers })
      setAddressList(response.data);
      setIsMigrating(response?.data?.migrating || false);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      const erro = error.response;

      if (erro) {
        const message = error.response.data.message;

        if(erro.data?.code == '422.049') {
          setShowCondoUnavailableModal(true);
        } else if (error.response.status !== 401) {
          toast.error(message || "Ocorreu um erro interno na aplicação");
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }

    recaptcharCount();
  }, [setLoading, requestGetAccessToken, setAddressList, toast, recaptcharCount]);

  const requestGetCondominiusByCode = useCallback(async (code, type = "code") => {
    setLoading(true);
    const access_token = await requestGetAccessToken();
    const headers = {
      access_token
    }
    try {
      const response = await api.get(`industrial/customer/v1/condominiums/${code}?document=${document}`, { headers });
      setLoading(false);
      const { data } = response;
      setIsMigrating(data?.migrating || false);

      if (!data.blocks.length) {
        return;
      }

      if (type === "code") {
        setCondominiumByCode(data);
      }
      if (type === "cep") {
        setAddressList(null);
        setcondominiumByZipCode(data);
      }
    } catch (error) {
      setLoading(false);
      const erro = error.response;
      if (erro) {
        const message = error.response.data.message;
        if (error.response.status !== 401) {

          if(erro.data?.code == '422.049') {
            setShowCondoUnavailableModal(true);
          } else if (error.response.data && error.response.data.code === "422.023") {
            toast.error(message);
          } else {
            toast.error(message);
          }
        }
      } else {
        if (error.response.status !== 401) {
          toast.error("Ocorreu um erro interno na aplicação");
        }
      }
    }
    setLoading(false);
    recaptcharCount();
  }, [setLoading, requestGetAccessToken, toast, setCondominiumByCode, setcondominiumByZipCode, setNumberAattempts, recaptcharCount]);

  const handleSearchCodeByCode = useCallback((values) => {
    setIsMigrating(false);
    setCondominiumByCode(null);
    const code = values.code.replace(/[^\d]/g, "");
    if (code) {
      requestGetCondominiusByCode(code, "code");
      dispatch(registerValuesMembership({ condoCode: values.code }));
    }

  }, [setCondominiumByCode, requestGetCondominiusByCode, dispatch, registerValuesMembership]);

  const handleSearchCodeByZipCode = useCallback((values) => {
    setIsMigrating(false);
    setcondominiumByZipCode(null);
    const cep = values.cep.replace(/[^\d]/g, "");

    if (values.addressCode) {
      requestGetCondominiusByCode(values.addressCode, "cep");
    } else {
      if (cep) {
        requestGetCondominiusByZipCode(cep);
      }
    }
    dispatch(registerValuesMembership({ condoZipCode: values.cep }));

  }, [setcondominiumByZipCode, requestGetCondominiusByZipCode, requestGetCondominiusByCode]);

  const handleSearchCode = useCallback((values, errors, setFieldTouched) => {
    setIsMigrating(false);
    resetReCapchar();
    if (reCapcharControler.token || !isProduction) {
      if (values.typeSelector === "code") {
        setFieldTouched("code", true);
        handleSearchCodeByCode(values);
      }

      if (values.typeSelector === "cep" && !errors.cep) {
        setFieldTouched("cep", true);
        handleSearchCodeByZipCode(values)
      }
    }
  }, [reCapcharControler, handleSearchCodeByCode, handleSearchCodeByZipCode, resetReCapchar]);

  const handleInputCodeChange = useCallback((event, handleChange, setFieldValue) => {
    setIsMigrating(false);
    handleChange(event);
    setFieldValue("condo", "");
    setFieldValue("blockIdSf", "");
    setFieldValue("unit", "");
    setCondominiumByCode(null)
  }, [setCondominiumByCode]);

  const handleInputZipCodeChange = useCallback((event, handleChange, setFieldValue) => {
    setIsMigrating(false);
    handleChange(event);
    setFieldValue("condo", "");
    setFieldValue("blockIdSfCep", "");
    setFieldValue("unitCep", "");
    setFieldValue("addressCode", "");
    setAddressList(null);
    setcondominiumByZipCode(null)
  }, [])

  const handleSelectedBlockByCode = useCallback((e, handleChange, setFieldValue) => {
    const id = e.target.value;
    const { blocks } = condominiumByCodeState;
    const selectedBlock = blocks.filter((block) => block.blockIdSf === id)[0];
    const index = blocks.findIndex((block) => block.blockIdSf === id);
    if (!selectedBlock.units.length) {
      toast.error("Um erro inesperado aconteceu. Tente novamente mais tarde.");
      return;
    }
    selectedBlock.name = selectedBlock.name ? selectedBlock.name : (selectedBlock.type === "AC" ? "AREA COMUM" : index + 1);
    setCondominiumByCode({ ...condominiumByCodeState, selectedBlock })
    setFieldValue("unit", "");
    handleChange(e);
  }, [condominiumByCodeState, setCondominiumByCode]);

  const handleSelectedUnitByCode = useCallback((e, handleChange) => {
    const id = e.target.value;
    const { selectedBlock } = condominiumByCodeState;
    const selectedUnit = selectedBlock.units.filter((unit) => unit.unitIdSf === id)[0];
    setCondominiumByCode({ ...condominiumByCodeState, selectedUnit });
    handleChange(e);
  }, [condominiumByCodeState, setCondominiumByCode]);

  const handleSelectedBlockByZipCode = useCallback((e, handleChange, setFieldValue) => {
    const id = e.target.value;
    const { blocks } = condominiumByZipCodeState;
    const selectedBlock = blocks.filter((block) => block.blockIdSf === id)[0];
    const index = blocks.findIndex((block) => block.blockIdSf === id);
    selectedBlock.name = selectedBlock.name ? selectedBlock.name : (selectedBlock.type === "AC" ? "AREA COMUM" : index + 1);
    setcondominiumByZipCode({ ...condominiumByZipCodeState, selectedBlock })
    setFieldValue("unitCep", "");
    handleChange(e);
  }, [condominiumByZipCodeState, setcondominiumByZipCode]);

  const handleSelectedUnitByZipCode = useCallback((e, handleChange) => {
    const id = e.target.value;
    const { selectedBlock } = condominiumByZipCodeState;
    const selectedUnit = selectedBlock.units.filter((unit) => unit.unitIdSf === id)[0];
    setcondominiumByZipCode({ ...condominiumByZipCodeState, selectedUnit });
    handleChange(e);
  }, [condominiumByZipCodeState, setcondominiumByZipCode]);

  const validatorSchema = () => Yup.object().shape({
    typeSelector: Yup.string(),
    cep: Yup.string().when('typeSelector', {
      is: val => val === "cep",
      then: Yup.string().matches(/[0-9]{5}-[0-9]{3}/, "Cep inválido").required("É necessário digitar o CEP"),
      otherwise: Yup.string()
    }),
    code: Yup.string().when('typeSelector', {
      is: val => val === "code",
      then: Yup.string().required("É necessário digitar o código do condomínio"),
      otherwise: Yup.string()
    }),
    blockIdSf: Yup.string().when('typeSelector', {
      is: val => val === "code",
      then: Yup.string().required('É necessário selecionar um bloco')
    }),
    unit: Yup.string().when('typeSelector', {
      is: val => val === "code",
      then: Yup.string().required('É necessário selecionar uma unidade'),
      otherwise: Yup.string()
    }),
    blockIdSfCep: Yup.string().when('typeSelector', {
      is: val => val === "cep",
      then: Yup.string().required('É necessário selecionar um bloco')
    }),
    unitCep: Yup.string().when('typeSelector', {
      is: val => val === "cep",
      then: Yup.string().required('É necessário selecionar uma unidade'),
      otherwise: Yup.string()
    })
  });

  const buildFormattedObject = useCallback(({ condominiumObject, blockIdSf }) => {
    let condominium = { ...condominiumObject };
    let { condominiumIdSf, address, organizationId, selectedUnit, selectedBlock, name } = condominium;
    const { hasGasMeter, hasGasReleased } = membershipReducer.unit;
    const newUnit = {
      unitIdSf: selectedUnit.unitIdSf,
      unitInstanceId: selectedUnit.instanceId,
      name: selectedUnit.name,
      condominiumName: name,
      hasGasMeter,
      hasGasReleased,
    }
    address.complement = `${selectedBlock.name}, ${selectedUnit.name}`;

    return {
      document,
      address,
      condominiumIdSf,
      organizationId,
      blockIdSf,
      unit: newUnit
    }
  }, [membershipReducer])

  const handleSubmit = useCallback(async ({ blockIdSfCep, blockIdSf, typeSelector }) => {
    let formattedObject = {}
    let hasOwner = false;
    console.log({tok: reCapcharControler.token, isProduction})
    if (!reCapcharControler.token && isProduction) {
      return
    }
    if (typeSelector === "code") {
      setModalValues(condominiumByCodeState);
      formattedObject = buildFormattedObject({ condominiumObject: condominiumByCodeState, blockIdSf });
      hasOwner = !!condominiumByCodeState.selectedUnit.isOccupied;
    }

    if (typeSelector === "cep") {
      setModalValues(condominiumByZipCodeState);
      formattedObject = buildFormattedObject({ condominiumObject: condominiumByZipCodeState, blockIdSf: blockIdSfCep });
      hasOwner = !!condominiumByZipCodeState.selectedUnit.isOccupied;
    }

    await dispatch(registerValuesMembership({
      ...formattedObject,
      condominiumByCode: condominiumByCodeState,
      condominiumByZipCode: condominiumByZipCodeState,
      typeSelector
    }));

    if (hasOwner) {
      setShowModalSwitch(true);
    } else {
      setShowModalBond(true);
    }

  }, [isProduction, condominiumByCodeState, condominiumByZipCodeState, buildFormattedObject, dispatch, registerValuesMembership, setShowModalSwitch, setShowModalBond, setModalValues, reCapcharControler]);

  const handleOwnerName = useCallback((fullName) => {
    let nameList = fullName.split(" ");
    nameList = nameList.map(name => {
      let dots = "";
      const sliceName = name.slice(2, name.length - 1);
      for (let i = 0; i < (sliceName.length - 1); i++) {
        dots = dots + "*"
      }
      return name.replace(sliceName, dots);
    })
    return nameList.join(" ")

  }, []);

  return (
    <>
      <Container>
        <Header>
          <h1>Cadastre sua residência ou loja</h1>
          <h2>Para cadastrar digite o cep ou código do condomínio</h2>
        </Header>

        <Formik
          initialValues={{
            typeSelector: membershipReducer ? membershipReducer.typeSelector || "cep" : "cep",
            code: condoCode || "",
            cep: condoZipCode || "",
            addressCode: "",
            condo: "",
            blockIdSf: membershipReducer ? membershipReducer.blockIdSf || "" : "",
            unit: membershipReducer && membershipReducer.unit ? membershipReducer.unit.unitIdSf || "" : "",
            blockIdSfCep: membershipReducer ? membershipReducer.blockIdSf || "" : "",
            unitCep: membershipReducer && membershipReducer.unit ? membershipReducer.unit.unitIdSf || "" : ""
          }}
          onSubmit={handleSubmit}
          validationSchema={validatorSchema}
          render={({ setFieldValue, setFieldTouched, handleChange, handleBlur, values, errors, touched }) => (
            <FormContainer>
              <HeaderForm>
                <SelectTypeContainer>
                  <Selector
                    type="radio"
                    id="typeSelector"
                    name="typeSelector"
                    value="cep"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    defaultChecked={values.typeSelector === "cep"}
                  />
                  <ButtonSelect htmlFor="typeSelector">
                    <div>
                      <GoDot size={19} />
                      Pelo CEP
                    </div>
                  </ButtonSelect>
                  <Selector
                    type="radio"
                    id="condoCode"
                    name="typeSelector"
                    value="code"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    defaultChecked={values.typeSelector === "code"}
                  />
                  <ButtonSelect htmlFor="condoCode">
                    <div>
                      <GoDot size={19} />
                      Código do Condomínio
                    </div>
                  </ButtonSelect>
                </SelectTypeContainer>
                {values.typeSelector === "code" ? (
                  <Tooltip>
                    <div data-tip="question" data-for="question">
                      Como encontrar o código?

                      <button type="button">?</button>
                      <ReactTooltip
                        id="question"
                        place="top"
                        type="dark"
                        effect="solid"
                      >
                        O código de autocadastro pode ser obtido através do síndico, administradora do condomínio ou zeladoria
                      </ReactTooltip>
                    </div>
                  </Tooltip>
                ) : (
                  <a
                    href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                    target="_blank"
                  >
                    <Tooltip>
                      <div data-tip="question" data-for="question">
                        Não sei meu CEP

                        <button type="button">?</button>
                        <ReactTooltip
                          id="question"
                          place="top"
                          type="dark"
                          effect="solid"
                        >
                          Clique nesse link para ser redirecionado para o site dos correios e encontrar o seu CEP.
                        </ReactTooltip>
                      </div>
                    </Tooltip>
                  </a>
                )}
              </HeaderForm>
              <InputsContainer>
                {
                  values.typeSelector === "cep" ?
                    <TextField
                      id="cep"
                      name="cep"
                      inputMode="numeric"
                      label="Digite seu CEP *"
                      placeholder="Digite seu CEP *"
                      LeadingIcon={() => <GoLocation size={25} />}
                      mask="99999-999"
                      onClick={() => toast.dismiss()}
                      onBlur={handleBlur}
                      onChange={(e) => handleInputZipCodeChange(e, handleChange, setFieldValue)}
                      value={values.cep}
                      errorCondition={errors.cep && touched.cep}
                      errorMessage={errors.cep}
                    /> :
                    <TextField
                      id="code"
                      name="code"
                      inputMode="numeric"
                      label="Digite o código do condomínio *"
                      placeholder="Digite o código do condomínio *"
                      LeadingIcon={() => <MdContentCopy size={25} />}
                      onBlur={handleBlur}
                      onClick={() => toast.dismiss()}
                      onChange={(e) => handleInputCodeChange(e, handleChange, setFieldValue)}
                      value={values.code}
                      errorCondition={errors.code && touched.code}
                      errorMessage={errors.code}
                    />
                }
              </InputsContainer>
              {
                recaptchaKey &&
                numberAattempts > 3 &&
                reCapcharControler.show &&
                isProduction && (
                  <ReCAPTCHAContainer>
                    <ReCAPTCHA
                      ref={reCapcharRef}
                      sitekey={recaptchaKey}
                      hl="pt-BR"
                      onChange={token => setReCapcharControler({ ...reCapcharControler, token })}
                    />
                  </ReCAPTCHAContainer>
                )
              }

              {values.typeSelector === "cep" && values.cep.length > 5 && addressList && addressList.length > 0 && (reCapcharControler.token || !isProduction) && !condominiumByZipCodeState && (
                <CondoContainer>
                  <p>Selecione seu condomínio</p>
                  {addressList.map(address => (
                    <div key={address.code}>
                      <RadioField id={address.code} name="addressCode" value={address.code} onChange={handleChange} onBlur={handleBlur} checked={address.code === values.addressCode} />
                      <label htmlFor={address.code}>
                        <strong>{address.name}</strong><br />
                        {address.address.fullAddress}
                      </label>
                    </div>
                  ))}
                </CondoContainer>
              )}

              {values.typeSelector === "code" && condominiumByCodeState && (reCapcharControler.token || !isProduction) &&
                (
                  <SelectCondoConatoner>
                    <CondoSelectedContainer>
                      <CondoIcon>
                        <MdBusiness size={30} />
                      </CondoIcon>
                      <h1>{condominiumByCodeState.name}</h1>
                      <h2>{condominiumByCodeState.address.fullAddress}</h2>
                    </CondoSelectedContainer>
                    {
                      condominiumByCodeState.blocks.length > 0 && (
                        <>
                          <FieldSelect>
                            <div>
                              <select name="blockIdSf" onBlur={handleBlur} onChange={(e) => { handleSelectedBlockByCode(e, handleChange, setFieldValue) }} value={values.blockIdSf}>
                                <option disabled value="">Selecione seu bloco</option>
                                {
                                  condominiumByCodeState.blocks.map(
                                    (block, index) => (
                                      <option key={block.blockIdSf} value={block.blockIdSf}>  {block.name || index + 1} </option>
                                    )
                                  )
                                }
                              </select>
                            </div>
                            {errors.blockIdSf && touched.blockIdSf && errors.blockIdSf && (<Error>{errors.blockIdSf}</Error>)}
                          </FieldSelect>
                          <FieldSelect>
                            <div>
                              <select name="unit" onBlur={handleBlur} onChange={(e) => { handleSelectedUnitByCode(e, handleChange) }} value={values.unit}>
                                <option disabled value="">Selecione sua unidade</option>
                                {condominiumByCodeState.selectedBlock && condominiumByCodeState.selectedBlock.units && (
                                  condominiumByCodeState.selectedBlock.units.map(
                                    (unit) => (
                                      <option key={unit.unitIdSf} value={unit.unitIdSf}>  {unit.name} </option>
                                    )
                                  )
                                )}
                              </select>
                            </div>
                            {errors.unit && touched.unit && errors.unit && (<Error>{errors.unit}</Error>)}
                          </FieldSelect>
                        </>
                      )
                    }
                  </SelectCondoConatoner>
                )
              }
              {values.typeSelector === "cep" && condominiumByZipCodeState && (reCapcharControler.token || !isProduction) &&
                (
                  <SelectCondoConatoner>
                    <CondoSelectedContainer>
                      <CondoIcon>
                        <MdBusiness size={30} />
                      </CondoIcon>
                      <h1>{condominiumByZipCodeState.name}</h1>
                      <h2>{condominiumByZipCodeState.address.fullAddress}</h2>
                    </CondoSelectedContainer>
                    {
                      condominiumByZipCodeState.blocks.length > 0 && (
                        <>
                          <FieldSelect>
                            <div>
                              <select name="blockIdSfCep" onBlur={handleBlur} onChange={(e) => { handleSelectedBlockByZipCode(e, handleChange, setFieldValue) }} value={values.blockIdSfCep}>
                                <option disabled value="">Selecione seu bloco</option>
                                {
                                  condominiumByZipCodeState.blocks.map(
                                    (block, index) => (
                                      <option key={block.blockIdSf} value={block.blockIdSf}>  {block.name || index + 1} </option>
                                    )
                                  )
                                }
                              </select>
                            </div>
                            {errors.blockIdSf && touched.blockIdSf && errors.blockIdSf && (<Error>{errors.blockIdSf}</Error>)}
                          </FieldSelect>
                          <FieldSelect>
                            <div>
                              <select name="unitCep" onBlur={handleBlur} onChange={(e) => { handleSelectedUnitByZipCode(e, handleChange) }} value={values.unitCep}>
                                <option disabled value="">Selecione sua unidade</option>
                                {condominiumByZipCodeState.selectedBlock && condominiumByZipCodeState.selectedBlock.units && (
                                  condominiumByZipCodeState.selectedBlock.units.map(
                                    (unit) => (
                                      <option key={unit.unitIdSf} value={unit.unitIdSf}>  {unit.name} </option>
                                    )
                                  )
                                )}
                              </select>
                            </div>
                            {errors.unit && touched.unit && errors.unit && (<Error>{errors.unit}</Error>)}
                          </FieldSelect>
                        </>
                      )
                    }
                  </SelectCondoConatoner>
                )
              }
              <ButtonsContainer>
              {!((values.typeSelector === "code" && !values.unit) || (values.typeSelector === "cep" && !values.unitCep)) && (
                   isMigrating && (
                     <BlockMigration />
                   )
                 )}
                {(values.typeSelector === "code" && !values.unit) || (values.typeSelector === "cep" && !values.unitCep) ? (
                  <ContainedButton
                    block
                    type="button"
                    continue
                    loading={loading}
                    id="Avançar"
                    disabled={isMigrating}
                    width="100%"
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                    onClick={() => handleSearchCode(values, errors, setFieldTouched)}
                  >
                    {values.typeSelector === "cep" && values.addressCode ? "Continuar" : "Procurar"}
                  </ContainedButton>
                ) : (
                  <ContainedButton
                    block
                    type="submit"
                    continue
                    loading={loading}
                    id="Avançar"
                    width="100%"
                    disabled={isMigrating}
                    TrailingIcon={() => <IoMdArrowForward size={20} />}
                  >
                    Continuar
                  </ContainedButton>
                )}
                <OutlinedButton
                  width="100%"
                  disabled={loading}
                  LeadingIcon={() => <IoMdArrowBack size={20} />}
                  onClick={() => dispatch(toggleMembershipStep(1))}
                  color={theme.colors.purple}
                >
                  Voltar
                </OutlinedButton>
              </ButtonsContainer>
            </FormContainer>
          )}
        />
      </Container>

      <ModalStyle
        show={showModalBond}
        onHide={() => setShowModalBond(false)}
        centered
      >
        <ModalContainer>
          <ModalHeader >
            <div>
              <h2>Confirme os dados abaixo para continuar</h2>
              <MdClose size={24} onClick={() => setShowModalBond(false)} />
            </div>
            <h1>Deseja prosseguir com a vinculação da unidade?</h1>
          </ModalHeader >
          <ModalBody>
            <CondoIcon>
              <MdBusiness size={30} />
            </CondoIcon>
            <div>
              <p>
                <strong>{modalValues && modalValues.name}</strong><br />
                {modalValues && modalValues.address && modalValues.address.fullAddress}
              </p>
              <InfoCard>
                <p>
                  <strong>Bloco: </strong>
                  {modalValues && modalValues.selectedBlock && modalValues.selectedBlock.name}
                </p>
                <p>
                  <strong>Apartamento / Loja: </strong>
                  {modalValues && modalValues.selectedUnit && modalValues.selectedUnit.name}
                </p>
              </InfoCard>
            </div>
          </ModalBody>
          <ModalFooter>
            <ContainedButton color="#E34E2A" LeadingIcon={() => <MdClose size={24} />} onClick={() => setShowModalBond(false)}>
              Não
            </ContainedButton>
            <ContainedButton color="#75B943" LeadingIcon={() => <MdCheck size={24} />} onClick={() => dispatch(toggleMembershipStep(4))}>
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>

      <ModalStyle
        show={showModalSwitch}
        onHide={() => setShowModalSwitch(false)}
        centered
      >
        <ModalContainer>
          <ModalHeader >
            <div>
              <h2>Troca de titularidade</h2>
              <MdClose size={24} onClick={() => setShowModalSwitch(false)} />
            </div>
            <h1>Deseja prosseguir com a troca de titularidade para a unidade?</h1>
          </ModalHeader >
          <ModalBody>
            <CondoIcon>
              <MdBusiness size={30} />
            </CondoIcon>
            <div>
              <p>
                <strong>{modalValues && modalValues.name}</strong><br />
                {modalValues && modalValues.address && modalValues.address.fullAddress}
              </p>
              <InfoCard>
                <p><strong>DADOS DO RESPONSÁVEL ATUAL DA UNIDADE</strong></p><br />
                <p>
                  <strong>Nome: </strong>
                  {modalValues && modalValues.selectedUnit && handleOwnerName(modalValues.selectedUnit.owner)}
                </p>
                <p>
                  <strong>Documento: </strong>
                  {modalValues && modalValues.selectedUnit && modalValues.selectedUnit.owner_document}
                </p>
                <p>
                  <strong>Bloco: </strong>
                  {modalValues && modalValues.selectedBlock && modalValues.selectedBlock.name}
                </p>
                <p>
                  <strong>Apartamento / Loja: </strong>
                  {modalValues && modalValues.selectedUnit && modalValues.selectedUnit.name}
                </p>
              </InfoCard>
            </div>
          </ModalBody>
          <ModalFooter>
            <ContainedButton color="#E34E2A" LeadingIcon={() => <MdClose size={24} />} onClick={() => setShowModalSwitch(false)}>
              Não
            </ContainedButton>
            <ContainedButton color="#75B943" LeadingIcon={() => <MdCheck size={24} />} onClick={() => dispatch(toggleMembershipStep(4))}>
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>
      <CondoUnavailable show={showCondoUnavailableModal} toggleModal={setShowCondoUnavailableModal} />
    </>
  );
}

const mapStateToProps = state => ({
  name: state.membershipReducer.name,
  document: state.membershipReducer.document,
  phoneNumber: state.membershipReducer.phoneNumber,
  email: state.membershipReducer.email,
  birthdate: state.membershipReducer.birthdate,
  unit: state.membershipReducer.unit,
  condominiumByCode: state.membershipReducer.condominiumByCode,
  condominiumByZipCode: state.membershipReducer.condominiumByZipCode,
  condoCode: state.membershipReducer.condoCode,
  condoZipCode: state.membershipReducer.condoZipCode,
  membershipReducer: state.membershipReducer
});

export default connect(mapStateToProps)(Registration);
